<template>
  <a-spin :tip="loadingTip" :spinning="isloading">
    <div>
      <div class>
        <a-form :form="form" @submit="handleSubmit">
          <!-- <a-form-item label="编号" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }" >
            <a-input
              placeholder="请输入编号"
              v-decorator="[
          'name',
          {rules: [{ required: false, message: '请输入编号!' }],initialValue:info.name}
        ]"
            ></a-input>
          </a-form-item>-->

          <a-form-item label="名称" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入名称"
              v-decorator="[
          'name',
          {rules: [{ required: true, message: '请输入名称!' }],initialValue:info.name}
        ]"
            ></a-input>
          </a-form-item>

          <a-form-item label="描述" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入描述"
              v-decorator="[
          'description',
          {rules: [{ required: false, message: '请输入描述!' }],initialValue:info.description}
        ]"
            ></a-input>
          </a-form-item>

          <a-form-item label="类型" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-select v-model="info.type" placeholder="请选择" allowClear>
              <a-select-option :value="1">键值对</a-select-option>
              <a-select-option :value="2">树形</a-select-option>
              <a-select-option :value="4">标签</a-select-option>
              <!--<a-select-option :value="3">图形</a-select-option> -->
            </a-select>
          </a-form-item>

          <a-form-item :wrapper-col="{ span: 19, offset: 5 }">
            <pxkeji-btn name="保存" type="primary" htmlType="submit" />
          </a-form-item>
        </a-form>
      </div>
      <!-- <div class="pxkeji-modal-bottom">
      <pxkeji-btn
        name="保存"
        htmlType="submit"
        size="small"
        type="primary"
        class="pxkeji-modal-bottom-btn"
      />
      <pxkeji-btn name="取消" @click="sumbit" size="small" class="pxkeji-modal-bottom-btn"/>
      </div>-->
    </div>
  </a-spin>
</template>

<script>
var that;
export default {
  props: {
    infos: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      dis: this.disabled,
      info: {
        status: true
      },
      isloading: false,
      loadingTip: "加载中...",
      regionDatas: [],
      LevelDatas: [],
      fileList: [],
      previewVisible: false,
      previewImage: "",
      uploadImg: []
    };
  },
  mounted() {
    this.$nextTick(function() {
      // console.log("传过来的参数", this.id);
      console.log("asdasd", this.infos);
      that = this;
      if (this.infos.id) {
        //编辑
        this.getInfo();
      }
      //this.getRegionList();
      //this.getLevelList();
    });
  },
  methods: {
    sumbit() {
      this.$emit("callbackMethod");
    },
    getInfo() {
      this.isloading = true;
      this.$api.dictionaries
        .getById(this.infos.id)
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.info = res.data;
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          //  console.log("form", values);
          //  console.log("imgs", this.info.type);

          //  return false;

          if (that.infos.id) {
            //修改
            this.isloading = true;
            this.$api.dictionaries
              .update(
                that.infos.id,
                values.name,
                values.description,
                this.info.type
              )
              .then(res => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.$message.success(res.errorMsg);
                  this.$emit("callbackMethod");
                  //this.form.resetFields();
                } else {
                  this.$message.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
          } else {
            //新增
            this.isloading = true;
            this.loadingTip = "保存中...";
            this.$api.dictionaries
              .save(values.name, values.description, this.info.type)
              .then(res => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.$message.success(res.errorMsg);
                  this.$emit("callbackMethod");
                  //this.form.resetFields();
                } else {
                  this.$message.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
          }
        }
      });
    },

    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        }
      });
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    handleChange({ fileList }) {
      //console.log("上传", fileList);
      this.fileList = fileList;
    }
  }
};
</script>
<style>
</style>